import api, { APIURL, errorHandle } from '../api/api'

class Location {
    constructor(obj) {
        this.code = obj.code
        this.province = obj.province
        this.district = obj.district
        this.subdistrict = obj.subdistrict
    }
}

export const getAllLocations = () => {
    return new Promise((resolve, reject) => {
        api.get(APIURL.LOCATION)
            .then(response => {
                if (response.data.data) {
                    const list = response.data.data.map(obj => {
                        return new Location(obj)
                    })
                    resolve(list)
                } else {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}

export default Location